import React, { memo } from 'react';
import {
  TitleContainer,
  Title,
  Description,
  ContentContainer,
  Media
} from 'app/pages/Survey/Subject/elements';

function Statement() {
  return (
    <>
      <TitleContainer>
        <Title />
        <Description />
      </TitleContainer>
      <ContentContainer>
        <Media />
      </ContentContainer>
    </>
  );
}

export default memo(Statement);
